<template>
  <div class="form-group esma_form_group">
    <label v-if="showLabel " v-bind:for="fieldID" class="col-xs-4 control-label esma_form_label">{{fieldLabel}}</label>
        <div :class="fieldClass" style="padding:0px 0px 0px 5px;">
          <input
            :ref="fieldID"
            type="checkbox"
            v-bind:style="filedStyle + 'float:left;width: 20px;height:20px;'"
            :disabled="isDisabled"
            v-on:change="updateValue($event.target.value,$event.target)"
            v-bind:id="fieldID"
            v-bind:name="fieldID"
            v-bind:value="fieldValue"
            :checked="fieldValue == 1"
            class="form-control"
          >
          <label :for="fieldID" style="float:left;padding-top: 6px;font-weight: normal;font-size: 14px;">
              {{fieldSubLabel}}
          </label>
    </div>
  </div>
</template>
<script>
import Vue from 'vue'
import { bus } from "@/libs/bus";
export default {
  data() {
    return {
      local_value: null,
      checked_value: 1,
      local_disabled: false,
    };
  },
  methods: {
    onClick(b) {
      if (b.type == "add_to_input") {
        this.$refs.local_value.value = b.text;
        this.$store.state[this.stateCurrentEditing][this.fieldID] = b.text;
      }
      if (b.type == "link") {
        this.$router.push(b.link);
      }
      return false;
    },
    updateValue(d, d2) {
      if(typeof this.$store.state[this.stateCurrentEditing][this.fieldID] == "undefined"){
        this.$store.state[this.stateCurrentEditing][this.fieldID] = this.$store.state[this.stateCurrentRow][this.fieldID];
      }
      this.$store.state[this.stateCurrentEditing][this.fieldID] = this.$store.state[this.stateCurrentEditing][this.fieldID] == 1 ? 0 : 1;
      if (typeof this.$props.data.global_emit != "undefined") {
        bus.$emit(this.$props.data.global_emit, this.$store.state[this.stateCurrentEditing][this.fieldID]);
      }
    },
    getOption(name, def) {
      if (typeof this.$props.option[name] == "undefined") {
        return def;
      }
      return this.$props.option[name];
    }
  },
  computed: {
    localDisabled:{
        get(){
          return this.local_disabled;
        },
        set(v){
          this.local_disabled = v;
        }
      },
    stateCurrentRow(){
      if(typeof this.$props.data.state_current_row != "undefined"){
        return this.$props.data.state_current_row;
      }else{
        return "current_row";
      }
    },
    stateCurrentEditing(){
      if(typeof this.$props.data.state_current_editing != "undefined"){
        return this.$props.data.state_current_editing;
      }else{
        return "current_editing";
      }
    },
    stateIsEditingNew(){
      if(typeof this.$props.data.state_is_editing_new != "undefined"){
        return this.$props.data.state_is_editing_new;
      }else{
        return "is_editing_new";
      }
    },
    fieldClass() {
      return "col-xs-8";
    },
    fieldLabel() {
      return this.$props.data.label;
    },
    fieldSubLabel() {
      return this.$props.data.sub_label;
    },
    fieldValue() {
      return this.$store.state[this.stateCurrentRow][this.fieldID];
    },
    showLabel() {
      if (this.getOption("hide_label", false) == true) {
        return false;
      } else {
        return true;
      }
    },
    fieldTableName() {
      return this.$props.data.table_name;
    },
    fieldID() {
      return this.$props.data.id;
    },
    isDisabled() {
      return (
        this.localDisabled ||
        this.$props.data.disabled ||
        this.$props.read ||
        typeof this.$store.state[this.stateCurrentRow][this.fieldID] == "undefined"
      );
    },
    filedStyle() {
      var h = this.fieldRows * 20;
      var store_style = this.$store.state[this.stateCurrentRow.replace("current_row","current_field_style")][this.fieldID] || "";
      return (
        this.getOption(
          "field_style",
          this.$props.data.field_style || "height: " + h + "px !important;"
        ) || ""
      ) + store_style;
    }
  },
  props: ["data", "value", "option", "read"],
  mounted(){
    this.$props.data.ref_field = this;
    setInterval(()=>{
    },2000)

    if(this.$props.data.page_controller){
      this.$props.data.page_controller_msg = (options) =>{
        switch (options.cmd) {
          case "enable":
            this.localDisabled = false;
            break;
          case "disable":
            this.localDisabled = true;
            break;
          default:
            break;
        }
      }
    }
  }

};
</script>
<style scoped>
.form-control[disabled],
fieldset[disabled] .form-control {
  background-color: black;
}
.form-control {
  color: black;
}
.form-control::selection {
  color: white;
  background: #575757;
}
</style>



// WEBPACK FOOTER //
// checkbox.vue?52159d6f